(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/use-url-helper.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/use-url-helper.js');
'use strict';

const {
  logger
} = svs.playerLoginReact;

const updateQuerystringWithParamAndValue = (param, value) => {
  svs.utils.url.refreshQueryString();
  let targetPath = svs.utils.url.currentPathEncodedParams();
  targetPath = svs.utils.url.updateQueryStringParameter(targetPath, param, value);
  window.history.replaceState({}, '', targetPath);
};
const useUrlHelper = () => {
  const playerloginreact = ReactRedux.useSelector(state => state.playerloginreact);
  const navigateToReturnUrl = () => {
    svs.components.Storage.browser.remove('returnUrl', 'player-login', () => {});
    svs.utils.url.navigate(svs.utils.url.makeInternal(playerloginreact === null || playerloginreact === void 0 ? void 0 : playerloginreact.returnUrl, svs.core.urlMapping.get('startPage')));
  };

  const navigateToCancelUrl = () => {
    svs.utils.url.navigate(svs.utils.url.makeInternal(playerloginreact === null || playerloginreact === void 0 ? void 0 : playerloginreact.cancelUrl, svs.core.urlMapping.get('startPage')));
  };

  const handleIOS = () => {
    var _navigator, _svs;
    const userAgent = ((_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.userAgent) === null || _navigator === void 0 ? void 0 : _navigator.toLowerCase()) || '';
    const isNativeApp = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.isNativeApp;
    if (isNativeApp) {
      return encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutiken.bankid'));
    } else if (userAgent.indexOf('firefox') > -1 || userAgent.indexOf('fxios') > -1) {
      return encodeURIComponent('firefox://');
    } else if (userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg') > -1 || userAgent.indexOf('edgios') > -1) {
      if (window.location.protocol.indexOf('s') > -1) {
        return 'microsoft-edge-https://';
      }
      return 'microsoft-edge-http://';
    } else if (userAgent.indexOf('safari') > -1) {
      return encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
    }
    return 'null'; 
  };

  const getReturnUrl = function (token) {
    let isBankId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let returnUrl;
    const clientsideModelReturnUrl = (playerloginreact === null || playerloginreact === void 0 ? void 0 : playerloginreact.returnUrl) || svs.core.urlMapping.get('startPage');
    const clientsideModelCancelUrl = (playerloginreact === null || playerloginreact === void 0 ? void 0 : playerloginreact.cancelUrl) || svs.core.urlMapping.get('startPage');
    const clientsideModelRnc = (playerloginreact === null || playerloginreact === void 0 ? void 0 : playerloginreact.isReturnNewCustomer) || false;
    updateQuerystringWithParamAndValue('returnUrl', encodeURIComponent(clientsideModelReturnUrl));
    updateQuerystringWithParamAndValue('cancelUrl', encodeURIComponent(clientsideModelCancelUrl));
    updateQuerystringWithParamAndValue('rnc', clientsideModelRnc);
    updateQuerystringWithParamAndValue(isBankId ? 'ast' : 'authref', token);
    logger.debug("**** serversideModelReturnUrl: ".concat(clientsideModelReturnUrl, ", serversideModelCancelUrl: ").concat(updateQuerystringWithParamAndValue, ", serversideModelRnc: ").concat(clientsideModelRnc));
    if (svs.core.detect.browser.crios()) {
      if (window.location.protocol.indexOf('s') > -1) {
        returnUrl = 'googlechromes://';
      } else {
        returnUrl = 'googlechrome://';
      }
    } else if (svs.core.detect.os.iOS()) {
      returnUrl = handleIOS();
    } else {
      returnUrl = 'null';
    }
    logger.debug("Bankid/Freja eID return url: ".concat(returnUrl));
    return returnUrl;
  };

  const getFrejaeIdAppUrl = authRef => {
    let url;
    const urlEncodedAuthRef = encodeURIComponent(authRef);
    if (svs.core.detect.os.android()) {
      url = "frejaeid://bindUserToTransaction?transactionReference=".concat(urlEncodedAuthRef);
    } else if (svs.core.detect.formfactor.desktop()) {
      url = "frejaeid://bindUserToTransaction?transactionReference=".concat(urlEncodedAuthRef);
    } else {
      url = "frejaeid://bindUserToTransaction?transactionReference=".concat(urlEncodedAuthRef, "&originAppScheme=").concat(getReturnUrl(urlEncodedAuthRef, false));
    }
    logger.debug("Freja eID start url: ".concat(url));
    return url;
  };

  const getFrejaeIdQrData = authRef => {
    const urlEncodedAuthRef = encodeURIComponent(authRef);
    return "frejaeid://bindUserToTransaction?transactionReference=".concat(urlEncodedAuthRef);
  };

  const getBankIdAppUrl = autoStartToken => {
    let url;
    const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
    if (svs.core.detect.os.iOS() && !isNativeApp) {
      url = "https://app.bankid.com/?autostarttoken=".concat(autoStartToken, "&redirect=").concat(getReturnUrl(autoStartToken));
    } else if (svs.core.detect.formfactor.desktop()) {
      url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=null");
    } else {
      url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=").concat(getReturnUrl(autoStartToken));
    }
    logger.debug("Bankid start url: ".concat(url));
    return url;
  };
  return {
    navigateToReturnUrl,
    getFrejaeIdAppUrl,
    getBankIdAppUrl,
    navigateToCancelUrl,
    getFrejaeIdQrData
  };
};
svs.playerLoginReact.sharedComponents.useUrlHelper = useUrlHelper;

 })(window);